import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MewsTeam, RouteType } from '@mews/enums';
import { GenerateContract, TextKey } from '@mews-commander/contracts';
import { BusinessError } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

const searchParamsSchema = z
    .object({
        reservationId: z.string().uuid(),
        customerId: z.undefined(),
    })
    .or(
        z.object({
            customerId: z.string().uuid(),
            reservationId: z.undefined(),
        })
    );

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/ReservationContracts/Generate')({
    validateSearch: searchParamsSchema,
    beforeLoad: async ({ context: { ensureQueryData, checkFeatureFlag }, search }) => {
        checkFeatureFlag(FeatureFlag.contractingDocumentGenerationEnabled);

        if (!search.reservationId && !search.customerId) {
            throw new BusinessError('Either reservationId or customerId must be provided');
        }
        if (search.reservationId) {
            const { reservations } = await ensureQueryData('reservations', 'getAll', {
                reservationIds: [search.reservationId],
            });
            if (reservations?.length === 0) {
                throw new BusinessError(`Reservation with ID ${search.reservationId} not found`);
            }
        }
        if (search.customerId) {
            const { customers } = await ensureQueryData('accounts', 'getAll', {
                accountIds: [search.customerId],
            });
            if (customers?.length === 0) {
                throw new BusinessError(`Customer with ID ${search.customerId} not found`);
            }
        }
    },
    component: Component,
    staticData: {
        title: TextKey.ContractsGenerateContractTitle,
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
    },
});

function Component() {
    const search = Route.useSearch();

    return <GenerateContract {...search} />;
}
